import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { SEO } from "@/components/seo/SEO";

const SubscriptionCancelled = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO 
        title="Checkout Cancelled - Medical MCQ Subscription"
        description="Your subscription checkout was cancelled. You can try again anytime."
      />
      
      <div className="container py-12">
        <div className="max-w-2xl mx-auto text-center">
          <Card className="border-gray-200 bg-gray-50/50">
            <CardHeader className="pb-4">
              <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                <XCircle className="w-8 h-8 text-gray-600" />
              </div>
              <CardTitle className="text-2xl text-gray-800">
                Checkout Cancelled
              </CardTitle>
            </CardHeader>
            
            <CardContent className="pt-0 space-y-6">
              <p className="text-lg text-gray-700">
                Your subscription checkout was cancelled. No charges were made to your account.
              </p>
              
              <div className="p-4 bg-white rounded-lg border border-gray-200">
                <h3 className="font-semibold text-gray-800 mb-2">What's next?</h3>
                <ul className="text-sm text-gray-700 space-y-2 text-left">
                  <li>• You can try again anytime - your 3-day free trial is still available</li>
                  <li>• All plans include the same features, just different billing periods</li>
                  <li>• Card required but not charged during 3-day trial</li>
                  <li>• Cancel anytime during or after the trial</li>
                </ul>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  onClick={() => navigate('/pricing')}
                  className="bg-primary hover:bg-primary/90"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Try Again
                </Button>
                <Button 
                  variant="outline"
                  onClick={() => navigate('/dashboard')}
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Dashboard
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SubscriptionCancelled;
